
import router from '@/router';
import { defineComponent } from 'vue';
import { LocationQueryRaw, useRoute } from 'vue-router';

interface Menu {
  name: string,
  link: string,
  query?: LocationQueryRaw
}

export default defineComponent({
  props: {
    menuList: {
      type: Array,
      default: () => [] as Array<Menu>
    }
  },
  setup () {
    const route = useRoute()

    function handleLink (menu: Menu) {
      router.replace({ path: menu.link, query: menu.query || route.query })
    }
    return {
      route,
      handleLink
    }
  }
})
